"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = void 0;
// the base assert module doesn't use ts assertion syntax
function assert(value, message) {
    if (value == null) {
        throw new Error(message);
    }
}
exports.assert = assert;
//# sourceMappingURL=assert.js.map